import type { CSSProperties, ReactNode } from "react";
import { type LoopKind, loopPeriodMs, loopsCss } from "../../config/loops";
export type LoopProps = {
  kind: LoopKind;
  /** Marquee: px travelled per repeat; the period follows from the token's speed. */
  lap?: number;
  reverse?: boolean;
  /** Shimmer: sweep the box's own background so `backgroundClip: text` can clip it. */
  clipText?: boolean;
  style?: CSSProperties;
  children?: ReactNode;
};
type LoopStyle = CSSProperties & Record<`--${string}`, string>;

/** Shimmer slides the box across itself; with `clipText` it sweeps the box's background instead, for `backgroundClip: text`. Spin and marquee move the box. */
export function Loop({
  kind,
  lap = 0,
  reverse,
  clipText,
  style,
  children
}: LoopProps) {
  const running = kind !== "marquee" || lap > 0;
  const className = kind === "shimmer" && clipText ? "loop-shimmer-text" : `loop-${kind}`;
  const marquee: LoopStyle = kind === "marquee" ? {
    "--loop-period": `${loopPeriodMs(kind, lap)}ms`,
    "--loop-lap": `${-lap}px`,
    animationDirection: reverse ? "reverse" : undefined
  } : {};
  return <>
      {/* href + precedence let React hoist and dedupe this to one copy per document. */}
      <style href="loops" precedence="default">
        {loopsCss}
      </style>
      <div className={running ? className : undefined} style={{
      ...marquee,
      ...style
    }}>
        {children}
      </div>
    </>;
}